import(/* webpackMode: "eager" */ "/tmp/8de7783b91b8a56/app/[locale]/error.tsx");
